const ReactSelectStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 5,
    }),
    control: (base, state) => ({
        ...base,
        minHeight: "30px", // Adjust height as needed
        height: "30px",
        padding: 0,
        margin: 0,
        boxShadow: "none", // Remove shadow if necessary
        border: state.isDisabled ? "1px solid #ccc" : "1px solid #1976d2cc", // Border color set to #1976d2 with 80% opacity
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 6px", // Remove extra padding
        margin: 0,
        fontSize: "10px",
        flexWrap: "nowrap",
        overflow: "hidden",
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: "11px",
    }),
    singleValue: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
    }),
    indicatorContainer: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: 0,
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
    }),
    option: (base) => ({
        ...base,
        padding: "5px 10px", // You can adjust padding inside options
        fontSize: "10px",
        cursor: "pointer", // Change cursor to pointer
        zIndex: 5,
    }),
    noOptionsMessage: (base) => ({
        ...base,
        fontSize: "10px",
        padding: "5px 10px",
    }),
};

export default ReactSelectStyles;
